import { i18n } from '@muzly/shared/i18n';

import { queueProfileSync } from '@muzly/api-client';

import { DIAGNOSIS_FLOW, SETUP_FLOW } from './flow';
import { draftStore } from './storage';
import { pickAnswers, surveyStepById } from './survey';
import { saveProfile } from '../profile/profile';
import { toProfileBody } from '../profile/toProfileBody';

import type { OnboardingAnswer } from './flow';
import type { Profile } from '../profile/profile';

/**
 * 초기 설정 완료 — 답을 네 곳에 나눠 남긴다.
 *
 * 1. **프로필**(정본): 회차와 무관한 답. 게이트가 이걸 보고 홈을 연다.
 * 2. **설정 드래프트 삭제**: 다시 열어도 처음부터가 아니라 아예 안 열려야 한다(게이트).
 * 3. **회차 드래프트 시드**: 방금 답한 회차 질문(환경·컨디션)을 안내 자리에 둔다 — 홈에서
 *    곧바로 `진단하기`를 누르는 사람에게 두 화면 뒤에 같은 질문을 또 하지 않는다. 시간이
 *    지나 열어도 답이 stale할 뿐 산식에는 안 들어간다(회차 `survey` 메타로만 남는다).
 * 4. **서버로 보낼 큐**: 프로필 6키에 회차 답 둘(`environment`·`condition`)까지 얹는다 —
 *    서버 프로필은 온보딩 9필드를 다 들고, 회차 답도 거기가 정본이다. 여기서 보내지 않고
 *    쌓기만 하는 이유: 세션이 아직 안 섰을 수 있고(첫 부팅), 오프라인에서도 이 화면은
 *    끝나야 한다. 비우는 것은 `useProfileSync`가 한다.
 *
 * 회차 질문이 무엇인지는 진단 플로우가 정한다 — 그 플로우의 설문 단계. 답이 빠져 있으면
 * (있을 수 없지만 방어) 시드하지 않는다 — 진단이 처음부터 묻는다.
 */

const ROUND_KEYS = DIAGNOSIS_FLOW.steps.filter(
  (id) => surveyStepById(id) !== undefined,
);

export const completeSetup = (
  answers: Record<string, OnboardingAnswer>,
  completedAt: number = Date.now(),
): Profile => {
  const profile = saveProfile(answers, completedAt);
  queueProfileSync(
    toProfileBody(answers, i18n.resolvedLanguage ?? i18n.language),
  );
  draftStore(SETUP_FLOW).clear();

  if (ROUND_KEYS.every((key) => answers[key] !== undefined)) {
    draftStore(DIAGNOSIS_FLOW).save({
      index: DIAGNOSIS_FLOW.steps.indexOf('diagnosisIntro'),
      answers: pickAnswers(answers, ROUND_KEYS),
      report: null,
      reportSource: null,
    });
  }
  return profile;
};
